import React from "react";
import styled from "styled-components";
import { Button } from "../../components/custom";
import { Link } from "react-router-dom";
import { PATH_PAGE } from "../../routes/paths";
import { useDocumentTitle } from "../../hooks/useTitle";
import { Helmet } from "react-helmet";

export default function JSS1Admission() {
  useDocumentTitle("FGMS - Admission");

  const currentYear = new Date().getFullYear();
  const oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

  return (
    <Wrapper className="py-5">
      <Helmet>
        <title>
          JSS1 Enrollment - Entrance Examination | Firdaus-Gate Model Schools
        </title>
        <meta
          name="description"
          content="Enroll for JSS1 at Firdaus-Gate Model Schools. View entrance examination schedule and purchase admission forms online. Dates: July 5, August 9, and August 23, 2025."
        />
        <meta
          property="og:title"
          content="JSS1 Enrollment - Firdaus-Gate Model Schools"
        />
        <meta
          property="og:description"
          content="Enroll for JSS1 at Firdaus-Gate Model Schools. Entrance examinations scheduled for 2025/2026 academic year."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.firdaus-gate.com/admission/enrollment"
        />
        <meta
          property="og:image"
          content="https://www.firdaus-gate.com/favicon.ico"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="JSS1 Enrollment - Firdaus-Gate Model Schools"
        />
        <meta
          name="twitter:description"
          content="Enroll for JSS1. Entrance examinations scheduled for July, August 2025."
        />
        <link
          rel="canonical"
          href="https://www.firdaus-gate.com/admission/enrollment"
        />
      </Helmet>
      <div className="container">
        <p className="text-primary">ENTRANCE EXAMINATION</p>

        <div className="body-div mt-5">
          <h3>Schedule For Entrance Examinations</h3>
          <p className="mb-0 mt-3">
            Enrollment Now Open for{" "}
            {currentYear + "/" + oneYearFromNow.getFullYear()} &nbsp; Academic
            year <br />
            Entrance Examination Dates:
          </p>
          <ul className="mt-2">
            <li>
              - <b> 5th of July, 2025</b>
            </li>
            <li>
              - <b> 9th of August, 2025</b>
            </li>
            <li>
              - <b> 23rd of August, 2025</b>
            </li>
          </ul>
          Time : <b>9:00am</b> prompt <br />
          Venue : School Hall
        </div>
        <p className="mt-4">
          You can purchase admission form here on the school website by clicking
          on the button below, or you can visit the school at 6/8 Balogun
          Street, off Igodo Road, Omo-Olope Area, Magboro, Ogun State.
        </p>
        <Link to={PATH_PAGE.admissionForm}>
          <Button>Purchase Form</Button>
        </Link>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .container {
    width: 450px;
    margin: 0;
  }
  li {
    /* font-size: 19px !important; */
  }
`;
